/* src/app/component/make-payment/make-payment.component.scss */
.make-payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f5f5f5;
}
.status-box {
  width: 500px;
  height: 395px;
  background: #fff;
  border: 2px dashed #D0D5DD;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
.circle-outer {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #E0F7EC;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.circle-inner {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #A7F3D0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  font-size: 14px;
  font-weight: 600;
  color: #039855;
}
.approved-title {
  font-size: 18px;
  color: #039855;
  margin-top: 2px;
  font-weight: 600;
  margin-bottom: 6px;
}
.approved-message {
  font-size: 14px;
  color: #363F72;
  margin-top: 2px;
  margin-bottom: 16px;
}
.whats-next-box {
  background-color: #F2F4F7;
  border-radius: 12px;
  padding: 10px 24px 24px 24px;
  text-align: center;
  width: fit-content;
}
.whats-next-list {
  list-style-type: disc;
  padding-left: 0;
  margin: 0 auto 20px auto;
  display: inline-block;
  text-align: left;
  color: #667085;
  font-size: 14px;
}
.whats-next-list li {
  margin-bottom: 16px;
}
.add-payment-button {
  background-color: #FF8C00;
  color: #fff;
  padding: 12px 18px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 4px;
  cursor: pointer;
}
.add-payment-button:hover {
  background-color: #e67e00;
}
/*# sourceMappingURL=make-payment.component-57M2P463.css.map */
